import { compose } from "redux";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import { moneyFormater } from "../../../../../utilities/formaters";
import { accountBalanceConnector } from "../../../../../services/menu/dashboard/account.balance.connector";

const SavelendAccountBalance = (props) => {
  const currency = props.currency;

  const balanceFetched =
    props.accountBalance[currency].fetched &&
    !props.accountBalance[currency].fetching;

  if (balanceFetched) {
    let balance = props.accountBalance[currency].data;

    let slTax = balance.SavelendTax.Amount;
    let slFees = balance.SavelendFees.Amount;
    let invRecon = balance.InvestorRecon.Amount;
    let invRes = balance.InvestorsReserved.Amount;
    let invAvail = balance.InvestorsAvailable.Amount;
    let trustlyRecon = balance.TrustlyRecon.Amount;
    let swishRecon = balance.SwishRecon.Amount;

    return (
      <div>
        <Card
          style={{
            width: "50%",
            whiteSpace: "normal",
            display: "inline-block",
          }}
        >
          <CardHeader title="Savelend account balances" />
          <CardContent>
            <strong>Savelend tax</strong>:{" "}
            {moneyFormater(Math.floor(slTax * 100) / 100)} {currency}
            <br />
            <strong>Savelend fees</strong>:{" "}
            {moneyFormater(Math.floor(slFees * 100) / 100)} {currency}
            <br />
            <strong>Investor recon </strong>:{" "}
            {moneyFormater(Math.floor(invRecon * 100) / 100)} {currency}{" "}
            (unconfirmed deposits)
            <br />
            <strong>Investor reserved </strong>:{" "}
            {moneyFormater(Math.floor(invRes * 100) / 100)} {currency}{" "}
            (unconfirmed withdrawals)
            <br />
            <strong>Investor available </strong>:{" "}
            {moneyFormater(Math.floor(invAvail * 100) / 100)} {currency} <br />
            <strong>Trustly recon </strong>:{" "}
            {moneyFormater(Math.floor(trustlyRecon * 100) / 100)} {currency}
            <br />
            <strong>Swish recon </strong>:{" "}
            {moneyFormater(Math.floor(swishRecon * 100) / 100)} {currency}
            <br />
          </CardContent>
        </Card>
      </div>
    );
  }
  return <div>Loading</div>;
};

export default compose(accountBalanceConnector)(SavelendAccountBalance);
